import { Injectable, Signal } from "@angular/core";
import {
	UpdateNotificationIsRead,
	UpdateNotificationsAreRead,
} from "../command/notification.command";
import { asUtc } from "../helper/date.helper";
import { UUID } from "../model/entityReference.model";
import { Notification } from "../model/notification.model";
import { Page } from "../model/query.model";
import { ApiClient } from "../service/network/api.client";
import { NotificationStore } from "../store/notification.store";

@Injectable({
	providedIn: "root",
})
export class NotificationApi {
	constructor(
		private readonly api: ApiClient,
		private readonly store: NotificationStore,
	) {}

	public async fetch(id: string) {
		const notification = await this.api.get<Notification>(
			"/notification/" + id,
		);
		if (!notification) return;
		this.store.saveNotification(this.sanitize(notification));
	}
	public async fetchByUserId(id: string) {
		const page = await this.api.get<Page<Notification>>(
			"/notification/byUserId/" + id,
		);
		this.store.saveNotifications(
			page.content.map((notification) => this.sanitize(notification)),
		);
	}
	public async updateNotificationIsRead(command: UpdateNotificationIsRead) {
		await this.api.post("/notification/update-is-read", command);
		await this.fetch(command.id);
	}
	public async updateNotificationsAreRead(command: UpdateNotificationsAreRead) {
		await this.api.post("/notification/update-all-is-read", command);
		await this.fetchByUserId(command.userId);
	}

	public all(): Signal<Notification[] | undefined> {
		return this.store.entities;
	}

	public byId(id: UUID): Signal<Notification | undefined> {
		this.store.updateById(id);
		return this.store.byIdEntity;
	}

	private sanitize(notification: Notification): Notification {
		return { ...notification, createdAt: asUtc(notification.createdAt) };
	}
}
